jQuery(document).ready(function($) {

    let coinTContainers = document.querySelectorAll('.ctp-coin-table-container');  

    // check if there are tables on the page
    if (coinTContainers.length > 0) {

        coinTContainers.forEach(function(container) {           

            let dataLimit         = container.dataset.limit; 
            let containerId       = container.id;
            let parentOfContainer = container.parentElement;
            let parentWidth       = parentOfContainer.offsetWidth;    

            // classes to control the look and functionalities for smaller screens
            if( parentWidth < 1000 && parentWidth >= 850 ) {
                container.classList.add('ctp-below-1000');
            } else if ( parentWidth < 850 && parentWidth >= 768 ) {
                container.classList.add('ctp-below-850');
            } else if ( parentWidth < 768 && parentWidth >= 600 ) {
                container.classList.add('ctp-below-768');
            } else if ( parentWidth < 600 && parentWidth >= 480 ) {
                container.classList.add('ctp-below-600');
            } else if ( parentWidth < 480 && parentWidth >= 375 ) {
                container.classList.add('ctp-below-480');
            } else if ( parentWidth < 375 && parentWidth >= 320 ) {
                container.classList.add('ctp-below-375');
            } else if ( parentWidth < 320 ) {
                container.classList.add('ctp-below-320');
            }  


            /**
             * Sorting by columns
             */
            let cryptoTable   = document.getElementById(containerId);  
            let tableBody     = cryptoTable.querySelector('.ctp-coin-table-frame');      
            let cryptoRows    = Array.from(cryptoTable.querySelectorAll(".ctp-coin-table-row"));
            let headerT       = cryptoTable.querySelector(".ctp-coin-table-header");
            let rankSort      = headerT.querySelector(".ctp-coin-rank");
            let changeSort    = headerT.querySelector(".ctp-coin-change");
            let marketCapSort = headerT.querySelector(".ctp-coin-mc");
            let volumeSort    = headerT.querySelector(".ctp-coin-volume");
            let priceSort     = headerT.querySelector(".ctp-coin-price");
            
            let marketCapSortAsc = true;
            let volumeSortAsc    = true;
            let changeSortAsc    = true;
            let rankSortAsc      = true;
            let priceSortAsc     = true;

            function getCryptoRows() {
                return Array.from(tableBody.querySelectorAll(".ctp-coin-table-row"));
            }

            function sortTableByMarketCap() {

                let cryptoRows = getCryptoRows();

                cryptoRows.sort((a, b) => {
                    const marketCapA = parseFloat(a.querySelector(".ctp-coin-mc").getAttribute("data-number"));
                    const marketCapB = parseFloat(b.querySelector(".ctp-coin-mc").getAttribute("data-number"));
                    return marketCapSortAsc ? marketCapA - marketCapB : marketCapB - marketCapA;
                });
                marketCapSortAsc = !marketCapSortAsc;
                renderSortedRows(cryptoRows);
            }

            function sortTableByRank() {

                let cryptoRows = getCryptoRows();

                cryptoRows.sort((a, b) => {
                    const rankA = parseFloat(a.querySelector(".ctp-coin-rank").textContent);
                    const rankB = parseFloat(b.querySelector(".ctp-coin-rank").textContent);
                    if (rankSortAsc) {
                        return rankA - rankB;
                    } else {
                        return rankB - rankA;
                    }
                });
                rankSortAsc = !rankSortAsc;
                renderSortedRows(cryptoRows);
            }

            function sortTableByVolume() {

                let cryptoRows = getCryptoRows();

                cryptoRows.sort((a, b) => {
                    const volumeA = parseFloat(a.querySelector(".ctp-coin-volume").getAttribute("data-number"));
                    const volumeB = parseFloat(b.querySelector(".ctp-coin-volume").getAttribute("data-number"));
                    return volumeSortAsc ? volumeA - volumeB : volumeB - volumeA;
                });
                volumeSortAsc = !volumeSortAsc;
                renderSortedRows(cryptoRows);
            }

            function sortTableByChange() {

                let cryptoRows = getCryptoRows();

                cryptoRows.sort((a, b) => {
                    const changeA = parseFloat(a.querySelector(".ctp-coin-change").textContent);
                    const changeB = parseFloat(b.querySelector(".ctp-coin-change").textContent);
                    return changeSortAsc ? changeA - changeB : changeB - changeA;
                });
                changeSortAsc = !changeSortAsc; 
                renderSortedRows(cryptoRows);
            }

            function sortTableByPrice() {

                let cryptoRows = getCryptoRows();

                cryptoRows.sort((a, b) => {
                    const changeA = parseFloat(a.querySelector(".ctp-coin-price").getAttribute("data-number"));
                    const changeB = parseFloat(b.querySelector(".ctp-coin-price").getAttribute("data-number"));
                    return changeSortAsc ? changeA - changeB : changeB - changeA;
                });
                changeSortAsc = !changeSortAsc; 
                renderSortedRows(cryptoRows);
            }

            function renderSortedRows(rows) {                        
                let tableBody = cryptoTable.querySelector(".ctp-coin-table-frame");
                tableBody.innerHTML = "";   
                rows.forEach((row) => {
                    tableBody.appendChild(row);
                });
            }

            rankSort.addEventListener("click", sortTableByRank);
            changeSort.addEventListener("click", sortTableByChange);
            marketCapSort.addEventListener("click", sortTableByMarketCap);
            volumeSort.addEventListener("click", sortTableByVolume);
            priceSort.addEventListener("click", sortTableByPrice);

        });
    }

});



